export default "__VITE_ASSET__DXkgz2IX__"